import React from 'react';
import './App.css'
import Me from './components/Me';
import Navbar from './components/Navbar';
import About from './components/About';
import Skills from './components/Skills';
import Projects from './components/Projects';
import Contact from './components/Contact';
import '@fontsource/montserrat';

import { FaFacebookF, FaInstagram, FaGithub } from 'react-icons/fa';



function App() {
  return (
    <div>
      <Navbar />
      <div className='page-content'>
        <Me />
        <About />
        <Skills />
        <Projects />
        <Contact />
        <div className="social-media">
          <a href="https://www.facebook.com/hasdol/"><FaFacebookF /></a>
          <a href="https://www.instagram.com/hakonasdol/"><FaInstagram /></a>
          <a href="https://github.com/Haakoasd"><FaGithub /></a>
        </div>
      </div>
    </div>
  );
}

export default App;
